{
	"title": "Entry points",
	"page": {
		"title": "Entry Points",
		"intro": "The airports, land crossings and ferry terminals people arrive and leave through, the welcome desk at each, and the minutes transfers are timed with.",
		"add": "Add entry point",
		"count_one": "{{n}} entry point",
		"count_other": "{{n}} entry points",
		"footnote": "Pickup after landing is when the driver should be waiting: the landing time plus the time to clear arrival (immigration and bags). Drop-off before departure works the same way back.",
		"capacityNote": "Desk capacity is how many people the welcome desk can process in an hour (card handover and bags). The day board flags hours above it.",
		"capacityNotePeak": "Desk capacity is how many people the welcome desk can process in an hour (card handover and bags). The peak column is today's busiest hour of arrivals, in the games' time zone."
	},
	"filters": {
		"searchPlaceholder": "Name, code or IATA",
		"typeChips": "Type",
		"statusChips": "Status"
	},
	"sort": {
		"order": "Display order",
		"codeAsc": "Code A–Z",
		"type": "Type"
	},
	"table": {
		"entryPoint": "Entry point",
		"codeAndAirport": "{{code}} · {{airport}}",
		"iataTerminal": "{{iata}} {{terminal}}",
		"type": "Type",
		"desk": "Welcome desk",
		"timing": "Transfer timing",
		"pickupAfter": "Pickup {{n}} min after landing",
		"dropoffBefore": "Drop-off {{n}} min before departure",
		"capacity": "Desk capacity",
		"capacityValue": "{{n}} / hour",
		"capacityNotSet": "Not set",
		"peakOn": "Peak on {{day}}",
		"peakOf": "{{n}} of {{cap}} at {{time}}",
		"peakAt": "{{n}} at {{time}}",
		"noTravel": "No travel",
		"legs": "Travel",
		"status": "Status",
		"active": "Active",
		"inactive": "Inactive",
		"order": "Order",
		"editLabel": "Edit {{name}}",
		"deleteLabel": "Delete {{name}}",
		"deleteInUse": "{{name}} has travel booked through it. Deactivate it instead."
	},
	"pagination": {
		"summary_one": "{{from}}–{{to}} of {{total}} entry point",
		"summary_other": "{{from}}–{{to}} of {{total}} entry points",
		"empty": "No entry points"
	},
	"empty": {
		"filteredTitle": "No entry points match these filters",
		"filteredDescription": "Try a broader search, or clear the filters.",
		"noneTitle": "No entry points yet",
		"noneDescription": "Add the airports, land crossings and ferry terminals people come through.",
		"clearFilters": "Clear filters"
	},
	"form": {
		"addTitle": "Add entry point",
		"addDescription": "People pick it when they add an arrival or a departure.",
		"addSubmit": "Add entry point",
		"saveChanges": "Save changes",
		"minutesUnit": "min",
		"field": {
			"type": "Type",
			"typeFixed": "The type can't change once created. Add a new entry point instead.",
			"findAirport": "Find the airport",
			"findAirportHint": "Picking one fills the IATA code, and the name and code when they are empty. You can still edit everything.",
			"name": "Name",
			"code": "Code",
			"codeHint": "Short and unique: KLIA2, JHB-CIQ.",
			"iata": "IATA code",
			"iataHint": "The airport's 3 letters. KLIA Terminal 1 and 2 are both KUL.",
			"terminal": "Terminal",
			"terminalHint": "As flight data names it: 1, 2.",
			"desk": "Welcome desk",
			"deskHint": "The card handover location at this entry point.",
			"capacity": "Desk capacity",
			"capacityHint": "People the welcome desk can process in an hour. Used to flag busy hours on the day board.",
			"capacityInvalid": "Enter a whole number from 1 to 100,000",
			"dwell": "Time to clear arrival",
			"dwellHint": "Immigration and bags. Pickup = landing + this.",
			"lead": "Time before departure",
			"leadHint": "Check-in and security. Drop-off = departure − this.",
			"sortOrder": "Sort order",
			"sortOrderHint": "Pickers list by this.",
			"active": "Active",
			"activeHint": "Inactive entry points stay on past travel but can't be picked."
		},
		"placeholder": {
			"name": "KLIA Terminal 2",
			"findAirport": "City, airport or IATA code",
			"code": "KLIA2",
			"iata": "KUL",
			"terminal": "2",
			"desk": "Select",
			"capacity": "600"
		},
		"perHourUnit": "people / hour"
	},
	"delete": {
		"title": "Delete entry point",
		"description": "Delete <strong>{{name}}</strong>? If travel is already booked through it, deactivate it instead.",
		"confirm": "Delete entry point",
		"deleted": "{{name}} deleted.",
		"failed": "Couldn't delete entry point",
		"inUse": "Travel is already booked through this entry point. Deactivate it instead."
	},
	"toast": {
		"added": "{{name}} added.",
		"updated": "{{name}} updated.",
		"addFailed": "Couldn't add entry point",
		"updateFailed": "Couldn't update entry point"
	},
	"errors": {
		"codeTaken": "An entry point with that code already exists.",
		"invalidValue": "Invalid value"
	}
}
